module.exports = __webpack_public_path__ + "static/media/downloadLink.9bfe23b1.mp3";